import { Link } from 'react-router-dom';
import { FaArrowRight, FaStore } from 'react-icons/fa';

const ProviderCallout = () => (
  <section className="provider-callout-section section container">
    <div className="provider-callout">
      <div className="provider-callout__icon" aria-hidden="true"><FaStore /></div>
      <div className="provider-callout__copy">
        <span>Crece con nosotros</span>
        <h2>¿Tienes tu propio negocio? Únete a El Mercadito de Kila</h2>
        <p>Abre tu vitrina digital, llega a nuevos clientes y administra tus productos desde un solo lugar.</p>
      </div>
      <Link className="provider-callout__button" to="/quiero-ser-proveedor">
        Comenzar solicitud <FaArrowRight aria-hidden="true" />
      </Link>
    </div>
  </section>
);

export default ProviderCallout;
